import EnergyGuidesItem from './EnergyGuidesItem';
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import classNames from 'classnames';
import { useGetEnergiesGuide } from '../../../../hooks/energyGuides';
import { useTranslation } from 'react-i18next';

export default function EnergyGuidesList() {
  const { t } = useTranslation();
  const { data: energyGuides, isFetching, isError } = useGetEnergiesGuide();

  return (
    <div className="energy-guides">
      {!isFetching && !isError && (
        <h2 className="energy-guides__title">{t('energy.guides.title')}</h2>
      )}
      {(isFetching || isError) && (
        <div className="text-center">
          <Skeleton count={1} width={400} height={24} className="mb-4" />
        </div>
      )}
      <div className="energy-guides__carousel">
        <ul className="energy-guides__carousel__list">
          {!isFetching &&
            !isError &&
            energyGuides?.data.map((item, index) => (
              <EnergyGuidesItem
                className={
                  index === energyGuides.data.length - 1
                    ? 'energy-guides__carousel__item--no-gap'
                    : ''
                }
                key={item.content}
                item={item}
              />
            ))}
          {(isFetching || isError) &&
            [...Array(3)].map((item, index) => (
              <div key={index} className={classNames('w-100', { 'me-4': index !== 2 })}>
                <Skeleton count={1} height={150} width="100%" />
                <Skeleton count={1} width="90%" height={16} className="mt-4" />
                <Skeleton count={1} width="50%" height={16} className="mb-4" />

                <Skeleton count={1} width="70%" height={24} />
              </div>
            ))}
        </ul>
      </div>
    </div>
  );
}
